import DashboardView from '../DashboardView.vue'
import DashboardPage from '../Pages/DashboardPage.vue'

const routes = [
  {
    path: '/',
    redirect: { name: 'viajes-ride-list' },
    name: 'dashboard'
  },
  {
    // DEF-ADM-028 — dashboard operativo. Cuelga de DashboardView, que es el
    // que envuelve en <page-base>: sin ese padre la pantalla se monta sin
    // barra lateral ni cabecera, como pagina suelta.
    //
    // Vive en el menu de Administracion: compara ciudades, asi que es una
    // vista global y no una operacion dentro de una — por eso tiene "Todas".
    path: '/dashboard',
    component: DashboardView,
    name: 'dashboard-operativo-root',
    children: [
      {
        path: '',
        name: 'dashboard-operativo',
        component: DashboardPage,
        meta: { requiresAuth: true }
      }
    ]
  }
]

export default routes
